import styled from 'styled-components'
import { colors, fonts } from 'shared/lib'
import { FeatureFlag } from 'shared/enums/FeatureFlag'
import { useFeatureFlag } from 'featureFlags/hooks/useFeatureFlag'
import { CheckoutQA } from 'shared/dataAttributes'
import { t } from 'localization'
import { useUser } from 'shared/hooks/useUser'

const TP = 'checkout.components.AuthPanel.UserSummary'

const UserSummary = () => {
  const { currentUser, currentUserType } = useUser()
  const isGuestCheckout = useFeatureFlag(FeatureFlag.GUEST_CHECKOUT)

  if (isGuestCheckout && (currentUserType === 'registeredGuest' || currentUserType === 'guest')) {
    return (
      <Summary>
        <Title data-qa={CheckoutQA.AccountGuestClosedContentTitle}>
          {t(`${TP}.guestTitle`, 'Guest')}
        </Title>
        <p data-qa={CheckoutQA.AccountGuestClosedContentDescription}>
          {t(
            `${TP}.guesstDescription`,
            'You can continue to check out and create an account later.',
          )}
        </p>
      </Summary>
    )
  }
  if (currentUserType === 'loggedInUser') {
    return (
      <Summary>
        <Name data-qa={CheckoutQA.LoggedInUserName}>
          {currentUser?.name === 'Guest User'
            ? t(`${TP}.guestUser`, 'Guest User')
            : currentUser?.name}
        </Name>
        <Email data-qa={CheckoutQA.LoggedInUserEmail}>{currentUser?.email}</Email>
      </Summary>
    )
  }
  return null
}

const Summary = styled.div``

const Name = styled.div`
  font-size: 12px;
  color: ${colors.FC2_BLACK};
`
const Email = styled.div`
  font-size: 12px;
  margin-top: 5px;
  color: ${colors.FC2_GREY};
`
const Title = styled.h3`
  ${fonts.SUBTITLE_3}
  font-weight: normal;
`

export default UserSummary
